import React from 'react';
import { colors, fonts, sectionLabelStyle } from '../../patientintel/styles';
import { AIResearcherDemo } from '../../patientintel/AIResearcherDemo';

// Standalone Live Demo section per GSK_COPY_FOR_REVIEW.md [DEMO].

export const DemoSection = () => (
  <section
    style={{
      backgroundColor: colors.white,
      padding: '96px 48px',
      boxSizing: 'border-box',
    }}
  >
    <style>{`
      @media (max-width: 768px) {
        .gsk-demo-wrap { padding-left: 24px !important; padding-right: 24px !important; padding-top: 64px !important; padding-bottom: 64px !important; }
      }
      @keyframes gsk-demo-pulse {
        0% { box-shadow: 0 0 0 0 rgba(232,146,124,0.55); }
        70% { box-shadow: 0 0 0 10px rgba(232,146,124,0); }
        100% { box-shadow: 0 0 0 0 rgba(232,146,124,0); }
      }
    `}</style>
    <div className="gsk-demo-wrap" style={{ maxWidth: '1100px', margin: '0 auto' }}>
      <div style={{ maxWidth: '760px', margin: '0 auto 40px', textAlign: 'center' }}>
        <p style={{ ...sectionLabelStyle, textAlign: 'center' }}>Live Demo</p>
        <h2
          style={{
            fontFamily: fonts.serif,
            fontSize: 'clamp(26px, 3vw, 40px)',
            fontWeight: 700,
            color: colors.charcoal,
            margin: '0 0 16px',
            lineHeight: 1.2,
          }}
        >
          See it in action.
          <br />
          <span style={{ fontStyle: 'italic', fontWeight: 400 }}>In real time.</span>
        </h2>
        <p
          style={{
            fontFamily: fonts.sans,
            fontSize: '17px',
            color: colors.warmGray,
            maxWidth: '620px',
            margin: '0 auto',
            fontWeight: 400,
            lineHeight: 1.65,
            textWrap: 'pretty',
          }}
        >
          The AI Research Assistant — turning a question into a patient inquiry, live. This is the same component we run on Real Patients' On-Demand Patient Intelligence through PRISM.
        </p>
      </div>

      <div style={{ textAlign: 'center', marginBottom: '24px' }}>
        <span
          style={{
            fontFamily: fonts.sans,
            fontSize: '11px',
            fontWeight: 700,
            letterSpacing: '2px',
            textTransform: 'uppercase',
            color: colors.deepCoral,
            display: 'inline-flex',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <span
            aria-hidden="true"
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: colors.terracotta,
              display: 'inline-block',
              boxShadow: `0 0 0 0 ${colors.terracotta}`,
              animation: 'gsk-demo-pulse 2s infinite',
            }}
          />
          Live
        </span>
      </div>
      <AIResearcherDemo />
    </div>
  </section>
);
